import { createApp, nextTick } from "vue";
import { key, store } from "@/store";
import router from "@/router";
import { setPlugins } from "@/GlobalPlugins";
import App from "@/App.vue";
import { FocusTrap } from "focus-trap-vue";
import { initFeatures } from "@/initFeatures";
import { initOpenTabHandler } from "@/initOpenTabHandler";
import VueKonva from "vue-konva";
import { createNaverMap } from "vue3-naver-maps";
import SelectBoxReactiveRenderer from "@/components/renderers/SelectBoxReactiveRenderer.vue";
import SelectBoxRenderer from "@/components/renderers/SelectBoxRenderer.vue";
import YNCheckboxRenderer from "@/components/renderers/YNCheckboxRenderer.vue";
import DatePickerEditor from "@/components/renderers/DatePickerEditor.vue";
import ButtonCellRenderer from "@/components/renderers/ButtonCellRenderer.vue";
import ResizePanel from "@/components/ui/ResizePanel.vue";
import { BCard, BTabs, BTab, BButton, BModal } from "bootstrap-vue-next";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "sweetalert2/dist/sweetalert2.min.css";
import "mdb-vue-ui-kit/css/mdb.min.css";
import "flatpickr/dist/flatpickr.css";
import "@vuepic/vue-datepicker/dist/main.css";
import "@/assets/styles/common.scss";
import SearchViewButton from "@/components/ui/SearchViewButton.vue";
import SearchWrap from "@/components/ui/SearchWrap.vue";

// AG Grid 29.3.5에서는 Enterprise 기능이 자동으로 활성화됨
// 별도의 모듈 등록이 필요하지 않음

// create app 이전에 처리가 되어야 routes가 정상작동한다
initFeatures();

const app = createApp(App);

// pass the injection key
app.use(store, key);
app.use(router);
app.use(VueKonva);

// Initialize Naver Maps

app.use(createNaverMap, {
  clientId: import.meta.env.VITE_NAVER_MAPS_CLIENT_ID || "YOUR_NAVER_MAPS_CLIENT_ID",
  enableAiMaps: false, // Optional, 기본값 true
  category: "ncp", // Optional
  subModules: [], // Optional,
});

setPlugins(app);

app.component("SelectBoxReactiveRenderer", SelectBoxReactiveRenderer);
app.component("SelectBoxRenderer", SelectBoxRenderer);
app.component("YNCheckboxRenderer", YNCheckboxRenderer);
app.component("DatePickerEditor", DatePickerEditor);
app.component("FocusTrap", FocusTrap);
app.component("ButtonCellRenderer", ButtonCellRenderer);
app.component("ResizePanel", ResizePanel);
app.component("SearchViewButton", SearchViewButton);
app.component("SearchWrap", SearchWrap);
app.component("BCard", BCard);
app.component("BTabs", BTabs);
app.component("BTab", BTab);

app.component("BButton", BButton);
app.component("BModal", BModal);

// 포트 설정
if (location.search.startsWith("?portInfo=")) {
  const portInfoQuery = location.search.replace("?portInfo=", "");
  const portInfoArr = portInfoQuery.split(":");
  localStorage.setItem("equipment", portInfoArr[0]);
  localStorage.setItem("port", portInfoArr[1]);
}

// 페이지 로드 시점에 레이아웃 상태 미리 설정 (깜빡임 방지)
const initializeLayoutState = () => {
  const currentPath = window.location.pathname;

  // 로그인 페이지인 경우 즉시 레이아웃 전환 클래스 적용
  if (currentPath === "/login") {
    document.body.classList.add("page-transition", "login-transition");

    // 탑메뉴바와 메인 레이아웃 요소들 즉시 숨김
    const topMenuBar = document.querySelector(".top-menu-bar");
    const mainLayout = document.getElementById("main-layout");

    if (topMenuBar) {
      (topMenuBar as HTMLElement).style.display = "none";
    }
    if (mainLayout) {
      mainLayout.style.display = "none";
    }
  } else {
    // 메인 페이지인 경우 로그인 전환 클래스 제거
    document.body.classList.remove("page-transition", "login-transition");

    const topMenuBar = document.querySelector(".top-menu-bar");
    const mainLayout = document.getElementById("main-layout");

    if (topMenuBar) {
      (topMenuBar as HTMLElement).style.display = "";
    }
    if (mainLayout) {
      mainLayout.style.display = "";
    }
  }
};

// DOM이 로드되기 전에 즉시 실행
initializeLayoutState();

// initOpenTabHandler는 라우터가 마운트된 후에 실행
if (window.location.pathname !== "/login") {
  nextTick(() => {
    initOpenTabHandler();
  });
}

app.mount("#app");
